import { Link } from "react-router-dom";
import { COMPLIANCE_DISCLOSURE } from "../lib/copy";

export default function Footer() {
  return (
    <footer className="relative pt-24 pb-40 overflow-hidden border-t" style={{ borderColor: "rgba(255,255,255,0.08)" }} data-testid="footer-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid md:grid-cols-3 gap-12 mb-16">
          <div data-testid="footer-license-col">
            <img src="/nexa-logo.png" alt="Nexa Lending" className="mb-6" style={{ height: 44, width: "auto" }} data-testid="footer-logo" />
            <p className="eyebrow mb-5" style={{ color: "#FFFFFF", fontSize: 12 }}>LICENSING</p>
            <div className="space-y-1 text-xs" style={{ color: "rgba(255,255,255,0.45)", lineHeight: 1.9 }}>
              <p className="font-bold" style={{ color: "rgba(240,236,228,0.8)" }}>Lake Group Homes LLC</p>
              <p>Licensed in NC, SC, GA, FL, TX, TN, CO, IN</p>
            </div>
          </div>
          <div data-testid="footer-contact-col">
            <p className="eyebrow mb-5" style={{ color: "#FFFFFF", fontSize: 12 }}>CONTACT</p>
            <div className="space-y-1 text-xs" style={{ color: "rgba(255,255,255,0.45)", lineHeight: 1.9 }}>
              <p><i className="fa-solid fa-phone mr-2" style={{ color: "rgba(61,123,255,0.6)" }}></i>980-298-1440</p>
              <p><i className="fa-solid fa-envelope mr-2" style={{ color: "rgba(61,123,255,0.6)" }}></i>mlake@nexalending.com</p>
            </div>
          </div>
          <div data-testid="footer-legal-col">
            <p className="eyebrow mb-5" style={{ color: "#FFFFFF", fontSize: 12 }}>LEGAL</p>
            <Link to="/privacy" className="footer-link" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="footer-link" data-testid="footer-terms-link">Terms of Use</Link>
          </div>
        </div>
        <div className="flex gap-4 items-start mb-10 pt-10 border-t" style={{ borderColor: "rgba(255,255,255,0.06)" }}>
          <span style={{ fontSize: 26, color: "rgba(255,255,255,0.4)", lineHeight: 1 }} title="Equal Housing Lender">⌂</span>
          <p style={{ fontSize: 10, color: "rgba(255,255,255,0.3)", lineHeight: 1.8, maxWidth: 1000 }} data-testid="compliance-disclosure">
            {COMPLIANCE_DISCLOSURE}
          </p>
        </div>
        <p className="mono" style={{ fontSize: 10, letterSpacing: "0.18em", color: "rgba(255,255,255,0.18)" }} data-testid="copyright-line">
          © 2026 NEXA LENDING · MATTHEW LAKE-NESTOR · WAM.WEBINAR v2.0
        </p>
      </div>
      <div className="footer-wordmark" data-testid="footer-wordmark">SEE THE WHOLE DEAL</div>
    </footer>
  );
}
